import { VideoType } from "../types/Asset.flow"
import { onClick as onClickVimeoButton } from "../../../../VimeoButton"
import { onClick as onClickVidyardButton } from "../../../../VidyardButton"

export default function openVideoModal({
  event,
  videoType
}) {
  if (videoType === "vidyard") {
    onClickVidyardButton(event)
  }

  if (videoType === "vimeo") {
    onClickVimeoButton(event)
  }
}